import { forwardRef } from 'react'
import { IFeedRecord } from '@/interfaces/IFeedRecord'
import styles from './FeedRow2.module.scss'
import { ITag } from '@/interfaces/ITag'
import AvatarBar from './AvatarBar'
import ChipBar from './ChipBar'
import TextSection from './TextSection'
import ImageSection from './ImageSection'

interface FeedRowProps {
  record: IFeedRecord
  selectedTag?: ITag | null
  // eslint-disable-next-line no-unused-vars
  openReportDialog: (id: string) => void
}

const FeedRow = forwardRef<HTMLDivElement, FeedRowProps>(({ record, selectedTag, openReportDialog }: FeedRowProps, ref) => {
  return (
    <div className={styles.wrapper} ref={ref}>
      <AvatarBar
        record={record}
        openReportDialog={(id: string) => {
          openReportDialog(id)
        }}
      />
      <div className={styles.recordLink}>
        <div
          className={styles.recordLeft}
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <TextSection
            record={record}
          />
          <ChipBar
            record={record}
            selectedTag={selectedTag}
          />
        </div>
        <div className={styles.recordRight}>
          <ImageSection
            record={record}
          />
        </div>
      </div>
    </div>
  )
})

FeedRow.displayName = 'FeedRow'

export default FeedRow
